// @core/api/endpoints/workflow/save_draft.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineVersionResponse,
  SaveDraftRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Save draft version
 * Saves the current state of the visual editor as the draft version. Replaces all nodes and connections in the draft with the provided data.
 */
export async function SaveDraft(
  pipeline_id: string,
  data: SaveDraftRequest,
  options?: RequestOptions
): Promise<PipelineVersionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id/draft`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.put<PipelineVersionResponse>(requestPath, data, requestOptions);
}
